import { BREAKPOINTS } from '~/constants';
export const IMAGE_WIDTH = {
    desktop: 652,
    desktopMedium: 608,
    desktopWide: 908,
    mobile: BREAKPOINTS.mobile,
    mobileMedium: BREAKPOINTS.mobileMedium,
    mobileWide: BREAKPOINTS.mobileWide,
    tablet: 652,
};
